const FAVORITES_KEY = 'biofleet_truck_favorites_v1';
const RECENTS_KEY = 'biofleet_truck_recents_v1';

function safeParse(json, fallback) {
  try {
    const parsed = JSON.parse(json);
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

function loadArray(key) {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(key);
  const value = safeParse(raw || '[]', []);
  return Array.isArray(value) ? value : [];
}

function saveArray(key, value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function getFavoriteTruckIds() {
  return loadArray(FAVORITES_KEY).filter((v) => Number.isFinite(Number(v))).map((v) => Number(v));
}

export function isFavoriteTruck(truckId) {
  const id = Number(truckId);
  return getFavoriteTruckIds().includes(id);
}

export function toggleFavoriteTruck(truckId) {
  const id = Number(truckId);
  const prev = getFavoriteTruckIds();
  const next = prev.includes(id) ? prev.filter((x) => x !== id) : [id, ...prev];
  saveArray(FAVORITES_KEY, next.slice(0, 100));
  window.dispatchEvent(new Event('prefsUpdated'));
  return next;
}

export function getRecentTruckEntries() {
  const entries = loadArray(RECENTS_KEY);
  return entries
    .filter((e) => e && Number.isFinite(Number(e.id)) && Number.isFinite(Number(e.ts)))
    .map((e) => ({ id: Number(e.id), ts: Number(e.ts) }))
    .sort((a, b) => b.ts - a.ts);
}

export function getRecentTruckIds(limit = 8) {
  return getRecentTruckEntries().slice(0, limit).map((e) => e.id);
}

export function recordTruckRecent(truckId) {
  const id = Number(truckId);
  if (!Number.isFinite(id)) return;
  const now = Date.now();
  const prev = getRecentTruckEntries().filter((e) => e.id !== id);
  const next = [{ id, ts: now }, ...prev].slice(0, 50);
  saveArray(RECENTS_KEY, next);
  window.dispatchEvent(new Event('prefsUpdated'));
}

